module.exports = __webpack_public_path__ + "media/img/home/animate/mobile/item1-842678f18701590e26e365b14c8a1b31.svg";